import { useQuery } from "@tanstack/react-query";
import { getServiceTemplateLastEditors } from "../../api/real-cookie-banner.js";
import { useStores } from "../../store/root.js";
import { QueryKeys } from "../../util/query-keys.js";
/**
 * Get last editors since release for given serviceTemplate via RCB Service API.
 */ function useGetServiceTemplateLastEditorsSinceRelease(id, enabled = true) {
    const { rcbAuthenticationStore } = useStores();
    return useQuery(QueryKeys.getServiceTemplateLastEditors(id), ({ signal })=>getServiceTemplateLastEditors({
            signal,
            language: "en",
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            },
            params: {
                id: String(id)
            }
        }), {
        staleTime: Infinity,
        retry: false,
        enabled: enabled && String(id)?.trim().length > 0 && !isNaN(Number(id))
    });
}
export { useGetServiceTemplateLastEditorsSinceRelease };
